export default __webpack_public_path__ + "static/media/popupdosite_Prancheta1.7f7d4e2e.png";